import { IChangePropertyPayload } from '@dash/editForm';
import actionsTypes from './actionTypes';
import {
  Attribute,
  IFieldTypes,
  ILoadDataSuccessPayload,
  IUpdateSettingsRequestPayload,
  ILoadAdminManagerSuccessPayload,
  IUpdateAdminManagerRequestPayload,
  ITouchPayload,
  IUpdateNCNSPeriodRequestPayload,
  IUpdateMinimumBookingTimeRequestPayload,
  IUpdateClockInPeriodRequestPayload,
  IUpdateFlaggedTimesheetsRequestPayload,
  IUpdateBulkJobsUploadRequestPayload,
  IUpdateWorkersBulkUploadRequestPayload,
  IUpdateBookingFulfillmentRequestPayload,
  IUpdateClockInOutRequestPayload,
  IUpdateAgencyWorkerRequestPayload,
  IUpdateAgenciesConfigurationsRequestPayload,
  ILoadInvoiceSortingRulesFormDataSuccessPayload,
  IChangeInvoiceSortingRulePayload,
  IRemoveInvoiceSortingRulePayload,
  IMoveInvoiceSortingRulePayload,
  IUpdateInvoiceSortingRulesRequestPayload,
  IUpdateInvoiceSortingRulesSuccessPayload,
} from './types';
import {
  ChangePropertyAction,
  LoadSettingsErrorAction,
  LoadSettingsRequestAction,
  LoadSettingsSuccessAction,
  UpdateSettingsErrorAction,
  UpdateSettingsRequestAction,
  UpdateSettingsSuccessAction,
  LoadAdminManagerSettingsRequestAction,
  LoadAdminManagerSettingsSuccessAction,
  UpdateAdminManagerSettingsRequestAction,
  UpdateAdminManagerSettingsSuccessAction,
  UpdateAdminManagerSettingsErrorAction,
  LoadAdminManagerSettingsErrorAction,
  TouchAction,
  LoadInvoiceSortingRulesFormDataRequestAction,
  LoadInvoiceSortingRulesFormDataSuccessAction,
  LoadInvoiceSortingRulesFormDataErrorAction,
  AddInvoiceSortingRuleAction,
  RemoveInvoiceSortingRuleAction,
  ChangeInvoiceSortingRuleAction,
  MoveInvoiceSortingRuleAction,
  UpdateInvoiceSortingRulesRequestAction,
  UpdateInvoiceSortingRulesSuccessAction,
  UpdateInvoiceSortingRulesErrorAction,
} from './actions.d';

const actions = {
  touch: (payload: ITouchPayload): TouchAction => ({
    type: actionsTypes.TOUCH,
    payload,
  }),

  changeProperty: (payload: IChangePropertyPayload<Attribute, IFieldTypes>): ChangePropertyAction => ({
    type: actionsTypes.CHANGE_PROPERTY,
    payload,
  }),

  loadSettingsRequest: (): LoadSettingsRequestAction => ({
    type: actionsTypes.LOAD_REQUEST,
  }),

  loadSettingsSuccess: (payload: ILoadDataSuccessPayload): LoadSettingsSuccessAction => ({
    type: actionsTypes.LOAD_SUCCESS,
    payload,
  }),

  loadSettingsError: (): LoadSettingsErrorAction => ({
    type: actionsTypes.LOAD_ERROR,
  }),

  updateSettingsRequest: (payload: IUpdateSettingsRequestPayload): UpdateSettingsRequestAction => ({
    type: actionsTypes.UPDATE_REQUEST,
    payload,
  }),

  updateSettingsSuccess: (): UpdateSettingsSuccessAction => ({
    type: actionsTypes.UPDATE_SUCCESS,
  }),

  updateSettingsError: (): UpdateSettingsErrorAction => ({
    type: actionsTypes.UPDATE_ERROR,
  }),

  loadAdminManagerSettingsRequest: (): LoadAdminManagerSettingsRequestAction => ({
    type: actionsTypes.LOAD_ADMIN_MANAGER_REQUEST,
  }),

  loadAdminManagerSettingsSuccess: (
    payload: ILoadAdminManagerSuccessPayload,
  ): LoadAdminManagerSettingsSuccessAction => ({
    type: actionsTypes.LOAD_ADMIN_MANAGER_SUCCESS,
    payload,
  }),

  loadAdminManagerSettingsError: (): LoadAdminManagerSettingsErrorAction => ({
    type: actionsTypes.LOAD_ADMIN_MANAGER_ERROR,
  }),

  updateAdminManagerSettingsRequest: (
    payload: IUpdateAdminManagerRequestPayload,
  ): UpdateAdminManagerSettingsRequestAction => ({
    type: actionsTypes.UPDATE_ADMIN_MANAGER_REQUEST,
    payload,
  }),

  updateAdminManagerSettingsSuccess: (): UpdateAdminManagerSettingsSuccessAction => ({
    type: actionsTypes.UPDATE_ADMIN_MANAGER_SUCCESS,
  }),

  updateAdminManagerSettingsError: (): UpdateAdminManagerSettingsErrorAction => ({
    type: actionsTypes.UPDATE_ADMIN_MANAGER_ERROR,
  }),

  // Global Configurations Actions
  updateNCNSPeriodRequest: (payload: IUpdateNCNSPeriodRequestPayload) => ({
    type: actionsTypes.UPDATE_NCNS_PERIOD_REQUEST,
    payload,
  }),

  updateNCNSPeriodSuccess: () => ({
    type: actionsTypes.UPDATE_NCNS_PERIOD_SUCCESS,
  }),

  updateNCNSPeriodError: () => ({
    type: actionsTypes.UPDATE_NCNS_PERIOD_ERROR,
  }),

  updateMinimumBookingTimeRequest: (payload: IUpdateMinimumBookingTimeRequestPayload) => ({
    type: actionsTypes.UPDATE_MINIMUM_BOOKING_TIME_REQUEST,
    payload,
  }),

  updateMinimumBookingTimeSuccess: () => ({
    type: actionsTypes.UPDATE_MINIMUM_BOOKING_TIME_SUCCESS,
  }),

  updateMinimumBookingTimeError: () => ({
    type: actionsTypes.UPDATE_MINIMUM_BOOKING_TIME_ERROR,
  }),

  updateClockInPeriodRequest: (payload: IUpdateClockInPeriodRequestPayload) => ({
    type: actionsTypes.UPDATE_CLOCK_IN_PERIOD_REQUEST,
    payload,
  }),

  updateClockInPeriodSuccess: () => ({
    type: actionsTypes.UPDATE_CLOCK_IN_PERIOD_SUCCESS,
  }),

  updateClockInPeriodError: () => ({
    type: actionsTypes.UPDATE_CLOCK_IN_PERIOD_ERROR,
  }),

  updateFlaggedTimesheetsRequest: (payload: IUpdateFlaggedTimesheetsRequestPayload) => ({
    type: actionsTypes.UPDATE_FLAGGED_TIMESHEETS_REQUEST,
    payload,
  }),

  updateFlaggedTimesheetsSuccess: () => ({
    type: actionsTypes.UPDATE_FLAGGED_TIMESHEETS_SUCCESS,
  }),

  updateFlaggedTimesheetsError: () => ({
    type: actionsTypes.UPDATE_FLAGGED_TIMESHEETS_ERROR,
  }),

  updateBulkJobsUploadRequest: (payload: IUpdateBulkJobsUploadRequestPayload) => ({
    type: actionsTypes.UPDATE_BULK_JOBS_UPLOAD_REQUEST,
    payload,
  }),

  updateBulkJobsUploadSuccess: () => ({
    type: actionsTypes.UPDATE_BULK_JOBS_UPLOAD_SUCCESS,
  }),

  updateBulkJobsUploadError: () => ({
    type: actionsTypes.UPDATE_BULK_JOBS_UPLOAD_ERROR,
  }),

  // Workers Bulk Upload Actions
  updateWorkersBulkUploadRequest: (payload: IUpdateWorkersBulkUploadRequestPayload) => ({
    type: actionsTypes.UPDATE_WORKERS_BULK_UPLOAD_REQUEST,
    payload,
  }),

  updateWorkersBulkUploadSuccess: () => ({
    type: actionsTypes.UPDATE_WORKERS_BULK_UPLOAD_SUCCESS,
  }),

  updateWorkersBulkUploadError: () => ({
    type: actionsTypes.UPDATE_WORKERS_BULK_UPLOAD_ERROR,
  }),

  // Manager Settings Actions
  updateBookingFulfillmentRequest: (payload: IUpdateBookingFulfillmentRequestPayload) => ({
    type: actionsTypes.UPDATE_BOOKING_FULFILLMENT_REQUEST,
    payload,
  }),

  updateBookingFulfillmentSuccess: () => ({
    type: actionsTypes.UPDATE_BOOKING_FULFILLMENT_SUCCESS,
  }),

  updateBookingFulfillmentError: () => ({
    type: actionsTypes.UPDATE_BOOKING_FULFILLMENT_ERROR,
  }),

  updateClockInOutRequest: (payload: IUpdateClockInOutRequestPayload) => ({
    type: actionsTypes.UPDATE_CLOCK_IN_OUT_REQUEST,
    payload,
  }),

  updateClockInOutSuccess: () => ({
    type: actionsTypes.UPDATE_CLOCK_IN_OUT_SUCCESS,
  }),

  updateClockInOutError: () => ({
    type: actionsTypes.UPDATE_CLOCK_IN_OUT_ERROR,
  }),

  // Agencies Configurations Actions
  updateAgenciesConfigurationsRequest: (payload: IUpdateAgenciesConfigurationsRequestPayload) => ({
    type: actionsTypes.UPDATE_AGENCIES_CONFIGURATIONS_REQUEST,
    payload,
  }),

  updateAgenciesConfigurationsSuccess: () => ({
    type: actionsTypes.UPDATE_AGENCIES_CONFIGURATIONS_SUCCESS,
  }),

  updateAgenciesConfigurationsError: () => ({
    type: actionsTypes.UPDATE_AGENCIES_CONFIGURATIONS_ERROR,
  }),

  // Invoices Configuration Actions
  loadInvoiceSortingRulesFormDataRequest: (): LoadInvoiceSortingRulesFormDataRequestAction => ({
    type: actionsTypes.LOAD_INVOICE_SORTING_RULES_FORM_DATA_REQUEST,
  }),

  loadInvoiceSortingRulesFormDataSuccess: (
    payload: ILoadInvoiceSortingRulesFormDataSuccessPayload,
  ): LoadInvoiceSortingRulesFormDataSuccessAction => ({
    type: actionsTypes.LOAD_INVOICE_SORTING_RULES_FORM_DATA_SUCCESS,
    payload,
  }),

  loadInvoiceSortingRulesFormDataError: (): LoadInvoiceSortingRulesFormDataErrorAction => ({
    type: actionsTypes.LOAD_INVOICE_SORTING_RULES_FORM_DATA_ERROR,
  }),

  addInvoiceSortingRule: (): AddInvoiceSortingRuleAction => ({
    type: actionsTypes.ADD_INVOICE_SORTING_RULE,
  }),

  removeInvoiceSortingRule: (payload: IRemoveInvoiceSortingRulePayload): RemoveInvoiceSortingRuleAction => ({
    type: actionsTypes.REMOVE_INVOICE_SORTING_RULE,
    payload,
  }),

  changeInvoiceSortingRule: (payload: IChangeInvoiceSortingRulePayload): ChangeInvoiceSortingRuleAction => ({
    type: actionsTypes.CHANGE_INVOICE_SORTING_RULE,
    payload,
  }),

  moveInvoiceSortingRule: (payload: IMoveInvoiceSortingRulePayload): MoveInvoiceSortingRuleAction => ({
    type: actionsTypes.MOVE_INVOICE_SORTING_RULE,
    payload,
  }),

  updateInvoiceSortingRulesRequest: (
    payload: IUpdateInvoiceSortingRulesRequestPayload,
  ): UpdateInvoiceSortingRulesRequestAction => ({
    type: actionsTypes.UPDATE_INVOICE_SORTING_RULES_REQUEST,
    payload,
  }),

  updateInvoiceSortingRulesSuccess: (
    payload: IUpdateInvoiceSortingRulesSuccessPayload,
  ): UpdateInvoiceSortingRulesSuccessAction => ({
    type: actionsTypes.UPDATE_INVOICE_SORTING_RULES_SUCCESS,
    payload,
  }),

  updateInvoiceSortingRulesError: (): UpdateInvoiceSortingRulesErrorAction => ({
    type: actionsTypes.UPDATE_INVOICE_SORTING_RULES_ERROR,
  }),

  // Agency Worker Configuration Actions
  updateAgencyWorkerRequest: (payload: IUpdateAgencyWorkerRequestPayload) => ({
    type: actionsTypes.UPDATE_AGENCY_WORKER_REQUEST,
    payload,
  }),

  updateAgencyWorkerSuccess: () => ({
    type: actionsTypes.UPDATE_AGENCY_WORKER_SUCCESS,
  }),

  updateAgencyWorkerError: () => ({
    type: actionsTypes.UPDATE_AGENCY_WORKER_ERROR,
  }),
};

export default actions;
